import React from 'react';
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { contactData } from '../data/mock';

export const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-blue-900 to-blue-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_eae76a40-ac03-4a31-a3ef-4e96d1f75339/artifacts/liore9ya_Logo%20%281%29.png" 
              alt="EduNexa Logo" 
              className="h-20 w-auto mb-4 filter brightness-125"
            />
            <p className="text-blue-200 leading-relaxed mb-6">
              Your trusted Canadian partner for OSSD and global university pathways. Empowering students to achieve their educational dreams worldwide.
            </p>
            <div className="flex space-x-3">
              <a
                href={contactData.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-800 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-all hover:scale-110"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={contactData.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-800 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-all hover:scale-110"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={contactData.socialMedia.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-800 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-all hover:scale-110"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-amber-400">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'About OSSD', id: 'about-ossd' },
                { name: 'Why EduNexa', id: 'why-edunexa' },
                { name: 'Program Structure', id: 'program' },
                { name: 'Universities', id: 'universities' },
                { name: 'Testimonials', id: 'testimonials' },
                { name: 'FAQ', id: 'faq' },
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-blue-200 hover:text-amber-400 transition-colors"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-amber-400">Study Streams</h4>
            <ul className="space-y-3 text-blue-200">
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Science Stream</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Business Stream</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Computing & Engineering</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">University Pathways</li>
              <li className="hover:text-amber-400 transition-colors cursor-pointer">Student Support Services</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-amber-400">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-amber-400 flex-shrink-0 mt-1" />
                <div>
                  <p className="text-blue-200">+1 (519) 500-5823</p>
                  <p className="text-blue-300 text-sm">WhatsApp: +1 (519) 500-5823</p>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-amber-400 flex-shrink-0 mt-1" />
                <p className="text-blue-200">info@edunexa.ca</p>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-amber-400 flex-shrink-0 mt-1" />
                <p className="text-blue-200">{contactData.contactInfo.address}</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-blue-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-blue-300 text-sm">
              © {new Date().getFullYear()} EduNexa. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <button className="text-blue-300 hover:text-amber-400 transition-colors">
                Privacy Policy
              </button>
              <button className="text-blue-300 hover:text-amber-400 transition-colors">
                Terms of Service
              </button>
              <button className="text-blue-300 hover:text-amber-400 transition-colors">
                Sitemap
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
